export default __webpack_public_path__ + "static/media/credit_card.5703c0db.jpg";